import QS from 'querystring';

import { randomString } from '@/utils';

export const groupStatusText = {
  WAIT_OPEN: '待开团',
  UNDERWAY: '成团中',
  SUCCESS: '拼团成功',
  FAIL: '拼团失败'
};

export const payStatusText = {
  WAIT_PAY: '待支付',
  PAY_SUCCESS: '支付成功',
  PAY_FAIL: '支付失败',
  REFUND: '退款'
};

export const groupDetailStatusText = {
  GROUP_START: '开团成功',
  GROUP_JOIN: '参团成功',
  GROUP_END: '拼团成功',
  GROUP_FAIL: '拼团失败',
  PAY_SUCCESS: '购买成功'
};

export const SiteUrl = {
  // 分享跳转海报
  SHARE: `/activity/poster/${randomString(6)}`,
  // 上传、关注跳转活动
  ACTIVE: `/activity`
};
// 获取站内跳转url
export function getJumpSiteUrl({
  action,
  activityId,
  actCode,
  channel,
  channelNo
}: {
  action: string;
  activityId: string | number;
  actCode: string;
  channel?: string;
  channelNo?: string;
}) {
  if (action === 'SHARE') {
    return `${(SiteUrl as any)[action]}?${QS.stringify({
      actId: activityId,
      actCode,
      channel,
      channelNo
    })}`;
  } else {
    return `${(SiteUrl as any).ACTIVE}/${'abc'}/${actCode}`;
  }
}

// 发放奖励类型
export const giveContentTypeText = {
  // MONEY: '现金',
  // PHYSICAL_GOODS: '实物', // id
  GOODS: '商品',
  USER_POINT: '成长豆',
  LABEL: '打标签', // id
  ASSIGN_ACT: '指定用户优惠', // id
  HUB: '内容资源'
  // LOTTERY: '抽奖',
  // COUPON: '指定活动id'
  // VIRTUAL_GOODS: '虚拟商品'
  // HUB: '资源包'
};

// 推荐人 content
export const initiativeContentText = {
  POSTER: '海报',
  SCREENSHOT: '截图',
  WECHAT_PUBLIC_ACCOUNT: '公众号'
};

// 推荐人行为
export const initiativeActionText = {
  SHARE: '分享',
  UPLOAD: '上传',
  FOLLOW: '关注'
  // LIFE_CYCLE_FIRST_UPLOAD: '生命周期首次上传',
};

export const InitiativeFrequencyText = {
  DAY: '每X天',
  TIME: '每X次',
  PERSON: '每X人'
};

// 被推荐人  内容
export const PassiveContentText = {
  EXPERIENCE_PACKAGE: '体验包',
  SYSTEM_PACKAGE: '系统包'
  // SEGMENT_PACKAGE: '主题包',
  // RESOURCE_PACKAGE: '资源包',
  // ALBUM: '专辑',
  // AUDIO: '音频',
};

// 被推荐人的 发放时机行为重定义
export const CustomerAction = {
  BUY: '购买',
  CLASS_BEGIN: '体验',
  CLASS_FINISH: '完成',
  SUBSCRIBE_BUY: '购买',
  PARTITION_BUY: '购买'
};

// 奖励发放时机的行为对应
export const PriceGetTimeActionText = {
  // 推荐人
  FOLLOW: '关注',
  BUY: '购买',
  SHARE: '分享',
  UPLOAD_SCREENSHOT_CHECK_PASS: '截图审核通过',
  UPLOAD_SCREENSHOT_FIRST_CHECK_PASS: '首次审核通过',
  // 被推荐人的
  CLASS_BEGIN: '开课',
  CLASS_FINISH: '完课',
  SUBSCRIBE_BUY: '购买',
  PARTITION_BUY: '购买'
};

export const PAGE_LOADING_STOP = 'page_loading_stop';

export const shareTypeText: any = {
  h5: 'H5领课',
  dynamic_mini_program: '小程序领课',
  mini_program_code: '小程序码领课'
};
